<template>
    <div style="margin-top: 32px;margin-bottom: 30px;">
        <Banner/>
        <Subject/>

    </div>
</template>

<script>
    import Banner from '../components/banner.vue'
    import Subject from '../components/subject.vue'
    export default {
        name: "Main",
        components: {
            Banner,
            Subject
        }
    }

</script>

